const data = {
	url: process.env.REACT_APP_SKIN,
	// url: 'http://127.0.0.1:3040/',
	// url: 'http://192.168.1.99:3040/',
	// url: "https://luck-api.flet.su/"
	// url: "https://a-luck-api.flet.su/"
};

export default data;
